// extracted by mini-css-extract-plugin
export default {"linkStyle":"DisBar_linkStyle__puM+2","barStyle":"DisBar_barStyle__rVy-L","pColor":"DisBar_pColor__dWuZ9","logoColor":"DisBar_logoColor__ttBZk","flexStyle":"DisBar_flexStyle__v1aeV"};